<template>
  <div class="checkbox-row">
    <div>
      <input
          type="checkbox"
          :id="props.id"
          :checked="props.modelValue"
          @change="(event: Event) => onChange(event)"
          :disabled="props.disabled"
      />
    </div>

    <label class="checkbox-label" :class="{ 'compact': props.compact }" :for="props.id">
      <span v-if="props.label" class="text-sm">{{ props.label }}</span>
      <span v-else><slot /></span>
    </label>
  </div>

  <ErrorList v-if="props.errors" :errors="props.errors" />
</template>

<script setup lang="ts">
import {ErrorObject} from "@vuelidate/core";
import ErrorList from "@/components/FormInputs/Partials/ErrorList.vue";

const emits = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const props = defineProps<{
  id: string;
  modelValue: boolean;
  compact?: boolean;
  errors?: ErrorObject[];
  label?: string;
  toolTipLabel?: string;
  disabled?: boolean; // Added disabled prop definition
}>();

function onChange(event: Event) {
  if (!(event.target instanceof HTMLInputElement)) return;
  emits('update:modelValue', event.target.checked);
}
</script>

<style scoped lang="scss">
@import '@/styles/form_input.scss';
</style>